import type { Environment } from '../types';

export const WAC_URL: Record<Environment, string> = {
	prod: 'https://www.atlassian.com',
	staging: 'https://wac.stg.internal.atlassian.com',
	dev: 'https://wac.stg.internal.atlassian.com',
	local: 'https://wac.stg.internal.atlassian.com',
} as const;
